import React from 'react'

// React Router
import { useNavigate } from 'react-router-dom';

// Assets
import logo from "../assets/logo.jpg";

// MUI
import { AppBar, Box, Toolbar, IconButton, Typography, Menu, Container, Avatar, Tooltip, MenuItem, styled } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCartOutlined';
import Badge, { badgeClasses } from '@mui/material/Badge';

// context
import { useContext } from 'react';
import { SpentContext } from "../contexts/SpentProvider";

export default function AppbarComp({ handleDrawerToggle }) {

    const myContext = useContext(SpentContext);
    const { count } = myContext;

    const navigate = useNavigate();

    const settings = ['Profile', 'Logout'];

    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleNavUserMenu = (param) => {
        setAnchorElUser(null);
        navigate(param !== "Logout" ? `/${param?.toLowerCase()}` : '/');
    };

    const CartBadge = styled(Badge)`
        & .${badgeClasses.badge} {
            top: -12px;
            right: -6px;
        }
    `;

    return (
        <AppBar position="sticky">
            <Container maxWidth="xl">
                <Toolbar disableGutters sx={{ gap: "15px", padding: "20px 0", justifyContent: "space-between", alignItems: "center", flexDirection: { sm: "row", xs: "column" } }}>
                    <Box sx={{ display: "flex", gap: "10px", justifyContent: "space-between", alignItems: "center" }}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ display: { sm: 'none' } }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" color="inherit">
                            {localStorage.getItem("username") || "Ali Hassan"}
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
                        <Tooltip title="Open Cart">
                            <IconButton onClick={() => {
                                navigate("/home");
                            }}>
                                <ShoppingCartIcon fontSize="small" color="inherit" />
                                <CartBadge badgeContent={count} color="info" overlap="circular" />
                            </IconButton>
                        </Tooltip>
                        <Box sx={{ flexGrow: 0 }}>
                            <Tooltip title="Open menu">
                                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                    <Avatar alt="spiderman" src={logo} />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                {settings.map((setting) => (
                                    <MenuItem key={setting} onClick={() => {
                                        handleNavUserMenu(setting);
                                    }
                                    }>
                                        <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    )
}
